<template>
  <div class="location" style="height: 300px">
    <div
      id="container"
      style="
        position: absolute;
        width: 701px;
        height: 300px;
        top: 50;
        left: -1px;
        border: 1px solid gray;
        overflow: hidden;
      "
    ></div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      map: {},
    };
  },
  props: {
    locationName: {
      type: String,
      default: "",
    },
    latitude: {
      type: Number | String,
      default: "",
    },
    longitude: {
      type: Number | String,
      default: "",
    },
  },

  mounted() {
    console.log(this.locationName, this.latitude, this.longitude);
    this.baiduMap();
    this.searchByLocationName();

    this.map.addEventListener("click", (e) => {
      this.map.clearOverlays();
      const { lat, lng } = e.point;
      console.log("纬度", lat);

      this.$store.commit("setLatitude", lat);
      this.$store.commit("setLongitude", lng);

      let marker = new BMap.Marker(new BMap.Point(lng, lat));
      this.map.addOverlay(marker);
    });
  },
  methods: {
    baiduMap() {
      this.map = new BMap.Map("container"); // 创建地图实例
      this.map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
    },

    searchByLocationName() {
      this.map.clearOverlays();
      let localSearch = new BMap.LocalSearch(this.map);
      localSearch.enableAutoViewport(); //允许自动调节窗体大小

      localSearch.search(this.locationName);

      localSearch.setSearchCompleteCallback((searchResult) => {
        let poi = searchResult.getPoi(0);
       

        if (this.latitude && this.longitude) {
          poi.point.lat = this.latitude;
          poi.point.lng = this.longitude;

        }

        this.$store.commit("setLatitude", poi.point.lat);
        this.$store.commit("setLongitude", poi.point.lng);

        this.map.centerAndZoom(poi.point, 15);
        let marker = new BMap.Marker(
          new BMap.Point(poi.point.lng, poi.point.lat)
        );
        this.map.addOverlay(marker);
      });
    },

    searchByChangeLocationName(newLocationName) {
      this.map.clearOverlays();
      let localSearch = new BMap.LocalSearch(this.map);
      localSearch.enableAutoViewport(); //允许自动调节窗体大小
      this.map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放

      localSearch.search(newLocationName);

      localSearch.setSearchCompleteCallback((searchResult) => {
        let poi = searchResult.getPoi(0);

        this.$store.commit("setLatitude", poi.point.lat);
        this.$store.commit("setLongitude", poi.point.lng);

        this.map.centerAndZoom(poi.point, 15);
        let marker = new BMap.Marker(
          new BMap.Point(poi.point.lng, poi.point.lat)
        );
        this.map.addOverlay(marker);
      });
    },
  },
  watch: {
    locationName(newValue) {
      console.log("地址已更新");
      this.locationName = newValue;
      this.searchByLocationName();
      this.searchByChangeLocationName(newValue)
    },
  },
};
</script>
<style scoped>
#container >>> .BMap_cpyCtrl {
  display: none;
}
#container >>> .anchorBL {
  display: none;
}
</style>